import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);




// SW регистрируется только из public/index.html (production).
// В CRA-dev / CloudPub лишний service-worker.js ломает ассеты.
reportWebVitals();
